import * as RadixSwitch from '@radix-ui/react-switch';
import { useId, type ReactNode } from 'react';
import { cx } from '../../utils/cx';
import s from './Switch.module.css';

export type SwitchProps = Omit<RadixSwitch.SwitchProps, 'children'> & {
  label: ReactNode;
  description?: ReactNode;
  /** Put the label before the switch (settings rows) or after it. */
  labelPosition?: 'start' | 'end';
};

export function Switch({
  label,
  description,
  labelPosition = 'start',
  id,
  className,
  ...rest
}: SwitchProps) {
  const autoId = useId();
  const swId = id ?? autoId;
  const descId = description ? `${swId}-desc` : undefined;
  return (
    <div className={cx(s.row, className)} data-label={labelPosition}>
      <div className={s.text}>
        <label htmlFor={swId} className={s.label}>
          {label}
        </label>
        {description ? (
          <p id={descId} className={s.description}>
            {description}
          </p>
        ) : null}
      </div>
      <RadixSwitch.Root id={swId} className={s.track} aria-describedby={descId} {...rest}>
        <RadixSwitch.Thumb className={s.thumb} />
      </RadixSwitch.Root>
    </div>
  );
}
